import { slugs } from 'common/constants/inputTypes'
import { buttonActionsTypes } from 'common/constants/settings'
import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import AudioNew from 'publisher/components/entities/AudioNew'
import BlogContentPlaceholderNew from 'publisher/components/entities/BlogContentPlaceholderNew'
import BlogPostContentPlaceholderNew from 'publisher/components/entities/BlogPostContentPlaceholderNew'
import BlogPageBody from 'publisher/components/entities/blog-page-body'
import { BlogPostBody } from 'publisher/components/entities/blog-post-body'
import { BlogPostLayoutBody } from 'publisher/components/entities/blog-post-layout-body'
import { Body } from 'publisher/components/entities/body'
import BookingCalendar from 'publisher/components/entities/booking-calendar/index'
import { PreviewBookingCalendar } from 'publisher/components/entities/booking-calendar/preview-booking-calendar'
import { RescheduleBookingCalendar } from 'publisher/components/entities/booking-calendar/reschedule-booking-calendar'
import ContentTable from 'publisher/components/entities/ContentTable'
import Countdown from 'publisher/components/entities/Countdown'
import BaseField from 'publisher/components/entities/Field/BaseField'
import CountryField from 'publisher/components/entities/Field/CountryField'
import EmailField from 'publisher/components/entities/Field/EmailField'
import PhoneNumberField from 'publisher/components/entities/Field/PhoneNumberField'
import Image from 'publisher/components/entities/Image'
import InlineBody from 'publisher/components/entities/inline-body'
import NewBulletList from 'publisher/components/entities/NewBulletList'
import NewHorizontalLine from 'publisher/components/entities/NewHorizontalLine'
import OptInButton from 'publisher/components/entities/OptInButton'
import { PopupNew } from 'publisher/components/entities/popup-new'
import RemotePopupBody from 'publisher/components/entities/remote-popup-body'
import StartTimer from 'publisher/components/entities/StartTimer'
import SurveyNew from 'publisher/components/entities/Survey/SurveyNew'
import TextNew from 'publisher/components/entities/TextNew'
import TwitterTweetButton from 'publisher/components/entities/TwitterTweetButton'
import VideoNew from 'publisher/components/entities/Video'
import BlogPostCategoriesNew from 'publisher/pages/blog-layout/components/BlogPostCategoriesNew'
import BlogPostDateNew from 'publisher/pages/blog-layout/components/BlogPostDateNew'
import BlogPostListingNew from 'publisher/pages/blog-page/components/BlogPostListingNew'
import LatestBlogPostsCarousel from 'publisher/pages/blog-page/components/LatestBlogPostsCarousel'
import LatestBlogPostsNew from 'publisher/pages/blog-page/components/LatestBlogPostsNew'
import PriceElement from 'publisher/pages/sale-page/components/price-element'
import { SearchResults } from 'publisher/pages/search-page/components/search-results'
import React from 'react'
import { Agreement } from 'src/publisher/entities/agreement'
import OptInButtonNew from 'src/publisher/entities/button-new'
import BlogSendFormButton from 'src/publisher/entities/button-new/blog-send-form-button'
import { Carousel } from 'src/publisher/entities/carousel'
import Checkbox from 'src/publisher/entities/checkbox/checkbox'
import { Faq } from 'src/publisher/entities/faq'
import BaseFieldNew from 'src/publisher/entities/field-new/base-field'
import CountryFieldNew from 'src/publisher/entities/field-new/country-field'
import EmailFieldNew from 'src/publisher/entities/field-new/email-field'
import PhoneNumberFieldNew from 'src/publisher/entities/field-new/phone-number-field'
import { Form } from 'src/publisher/entities/form'
import { Menu } from 'src/publisher/entities/menu'
import { Search } from 'src/publisher/entities/search/index'
import ContactUsButton from 'src/publisher/pages/contact-us/entities/contact-us-button'
import { ContactUsField } from 'src/publisher/pages/contact-us/entities/contact-us-field'
import WebinarSessionCallToActionNew from 'src/publisher/pages/webinar-session/entities/webinar-call-to-action-new'
import BlogCategoryDescription from '../../components/entities/BlogCategoryDescription'
import BlogCategoryTitle from '../../components/entities/BlogCategoryTitle'
import BlogPostImage from '../../components/entities/BlogPostImage'
import Breadcrumbs from '../../components/entities/Breadcrumbs'
import Column from '../../components/entities/Column'
import ContentBox from '../../components/entities/ContentBox'
import Headline from '../../components/entities/Headline'
import NewLanguageSwitcher from '../../components/entities/NewLanguageSwitcher'
import NewRawHtml from '../../components/entities/NewRawHtml'
import OptInRecaptcha from '../../components/entities/OptInRecaptcha'
import Row from '../../components/entities/Row'
import Section from '../../components/entities/Section'
import BlogPostTitleNew from '../../pages/blog-layout/components/BlogPostTitleNew'
import SendFormButton from '../../pages/blog-layout/entities/button/send-form-button'
import Attachments from '../../pages/contact-us/components/Attachments'
import ContactUs from '../../pages/contact-us/components/ContactUs'
import Recaptcha from '../../pages/contact-us/components/Recaptcha'
import TextArea from '../../pages/contact-us/components/TextArea'
import WebinarRegistrationDate from '../../pages/webinar-registration/components/WebinarRegistrationDate'
import WebinarSessionVideoNew from '../../pages/webinar-session/components/WebinarSessionVideoNew'
import WebinarSessionDateTimeNew from '../../pages/webinar-thank-you/components/WebinarSessionDateTime'
import WebinarSessionLinkNew from '../../pages/webinar-thank-you/components/WebinarSessionLinkNew'

export function isBlogPageAndButtonIsSendForm(pageType, buttonAction) {
  return (
    (pageType === PageTypeEnum.BlogHome ||
      pageType === PageTypeEnum.BlogPostBody ||
      pageType === PageTypeEnum.BlogPostListing ||
      pageType === PageTypeEnum.BlogSearch ||
      pageType === PageTypeEnum.BlogStatic) &&
    buttonAction === buttonActionsTypes.sendForm
  )
}

export default function createEntityElement(pageType) {
  return (entity, additionalProps = {}) => {
    const key = `entity-${entity.id}`
    switch (entity.type) {
      case EntityTypeEnum.Body:
        return <Body entity={entity} key={key} />
      case EntityTypeEnum.BlogPostBody:
      case EntityTypeEnum.WebsiteBlogPostBody:
        return <BlogPostBody entity={entity} key={key} />
      case EntityTypeEnum.BlogPageBody:
      case EntityTypeEnum.WebsiteBlogPageBody:
        return <BlogPageBody entity={entity} key={key} />
      case EntityTypeEnum.BlogPostLayoutBody:
      case EntityTypeEnum.WebsiteBlogPostLayoutBody:
        return <BlogPostLayoutBody entity={entity} key={key} />
      case EntityTypeEnum.Section:
        return <Section entity={entity} key={key} />
      case EntityTypeEnum.Row:
        return <Row entity={entity} key={key} />
      case EntityTypeEnum.Column:
        return <Column entity={entity} key={key} {...additionalProps} />
      case EntityTypeEnum.BulletList:
        return <NewBulletList entity={entity} key={key} />
      case EntityTypeEnum.BookingCalendar:
        return <BookingCalendar entity={entity} key={key} />
      case EntityTypeEnum.BookingCalendarPreview:
        return <PreviewBookingCalendar entity={entity} key={key} />
      case EntityTypeEnum.BookingCalendarReschedule:
        return <RescheduleBookingCalendar entity={entity} key={key} />
      case structureTypes.BUTTON:
        if (isBlogPageAndButtonIsSendForm(pageType, entity.options.action)) {
          return <SendFormButton entity={entity} key={key} />
        }
        return <OptInButton entity={entity} key={key} />
      case EntityTypeEnum.Button:
        if (isBlogPageAndButtonIsSendForm(pageType, entity.action)) {
          return <BlogSendFormButton entity={entity} />
        }
        return <OptInButtonNew entity={entity} key={key} />
      case structureTypes.FORM_INPUT:
        switch (entity.options.slug) {
          case slugs.EMAIL:
            return <EmailField entity={entity} />
          case slugs.COUNTRY:
            return <CountryField entity={entity} />
          case slugs.PHONE_NUMBER:
            return <PhoneNumberField entity={entity} />
          default:
            return <BaseField entity={entity} />
        }
      case EntityTypeEnum.Field:
        switch (entity.slug) {
          case slugs.EMAIL:
            return <EmailFieldNew entity={entity} />
          case slugs.COUNTRY:
            return <CountryFieldNew entity={entity} />
          case slugs.PHONE_NUMBER:
            return <PhoneNumberFieldNew entity={entity} />
          default:
            return <BaseFieldNew entity={entity} key={key} />
        }
      case EntityTypeEnum.Form:
        return <Form entity={entity} key={key} />
      case EntityTypeEnum.RemotePopupBody:
        return (
          <RemotePopupBody entity={entity} key={key} {...additionalProps} />
        )
      case EntityTypeEnum.InlineBody:
        return <InlineBody entity={entity} key={key} />
      case EntityTypeEnum.ContentBox:
        return <ContentBox entity={entity} key={key} />
      case EntityTypeEnum.WebinarSessionLink:
        return <WebinarSessionLinkNew entity={entity} key={key} />
      case EntityTypeEnum.WebinarSessionDateTime:
        return <WebinarSessionDateTimeNew entity={entity} key={key} />
      case EntityTypeEnum.WebinarCallToAction:
        return <WebinarSessionCallToActionNew entity={entity} key={key} />
      case EntityTypeEnum.WebinarSessionVideo:
        return <WebinarSessionVideoNew entity={entity} key={key} />
      case EntityTypeEnum.RawHtml:
        return <NewRawHtml entity={entity} key={key} />
      case EntityTypeEnum.Checkbox:
        return <Checkbox entity={entity} key={key} />
      case structureTypes.START_TIMER:
        return <StartTimer entity={entity} key={key} />
      case EntityTypeEnum.Countdown:
        return <Countdown entity={entity} key={key} />
      case EntityTypeEnum.BlogContentPlaceholder:
        return <BlogContentPlaceholderNew entity={entity} key={key} />
      case EntityTypeEnum.BlogPostContentPlaceholder:
        return <BlogPostContentPlaceholderNew entity={entity} key={key} />
      case EntityTypeEnum.BlogPostTitle:
        return <BlogPostTitleNew entity={entity} key={key} />
      case EntityTypeEnum.BlogPostCategories:
        return <BlogPostCategoriesNew entity={entity} key={key} />
      case EntityTypeEnum.BlogPostListing:
        return <BlogPostListingNew entity={entity} key={key} />
      case EntityTypeEnum.LatestBlogPosts:
        return <LatestBlogPostsNew entity={entity} key={key} />
      case EntityTypeEnum.BlogPostDate:
        return <BlogPostDateNew entity={entity} key={key} />
      case EntityTypeEnum.Menu:
        return <Menu entity={entity} key={key} />
      case EntityTypeEnum.LanguageSwitcher:
        return <NewLanguageSwitcher entity={entity} key={key} />
      case EntityTypeEnum.HorizontalLine:
        return <NewHorizontalLine entity={entity} key={key} />
      case EntityTypeEnum.TwitterTweetButton:
        return <TwitterTweetButton entity={entity} key={key} />
      case EntityTypeEnum.Survey:
        return <SurveyNew entity={entity} key={key} />
      case EntityTypeEnum.Carousel:
        return <Carousel entity={entity} key={key} />
      case EntityTypeEnum.Faq:
        return <Faq entity={entity} key={key} />
      case EntityTypeEnum.PriceElement:
        return <PriceElement key={key} />
      case EntityTypeEnum.WebinarRegistrationDate:
        return <WebinarRegistrationDate entity={entity} key={key} />
      case EntityTypeEnum.Text:
        return <TextNew entity={entity} key={key} />
      case EntityTypeEnum.Headline:
        return <Headline entity={entity} key={key} />
      case EntityTypeEnum.BlogPostImage:
        return <BlogPostImage entity={entity} key={key} />
      case EntityTypeEnum.ContentTable:
        return <ContentTable entity={entity} key={key} />
      case EntityTypeEnum.ContactUs:
        return <ContactUs entity={entity} key={key} />
      case EntityTypeEnum.ContactUsField:
        return <ContactUsField entity={entity} key={key} />
      case EntityTypeEnum.ContactUsButton:
        return <ContactUsButton entity={entity} key={key} />
      case EntityTypeEnum.Recaptcha:
      case EntityTypeEnum.ContactUsRecaptcha:
        return <Recaptcha entity={entity} key={key} />
      case EntityTypeEnum.OptInRecaptcha:
        return <OptInRecaptcha entity={entity} key={key} />
      case EntityTypeEnum.TextArea:
        return <TextArea entity={entity} key={key} />
      case EntityTypeEnum.Breadcrumbs:
        return <Breadcrumbs entity={entity} key={key} />
      case EntityTypeEnum.Attachments:
        return <Attachments entity={entity} key={key} />
      case EntityTypeEnum.Video:
        return <VideoNew entity={entity} key={key} />
      case EntityTypeEnum.Image:
        return <Image entity={entity} key={key} />
      case EntityTypeEnum.BlogCategoryTitle:
        return <BlogCategoryTitle entity={entity} key={key} />
      case EntityTypeEnum.BlogCategoryDescription:
        return <BlogCategoryDescription entity={entity} key={key} />
      case EntityTypeEnum.LatestBlogPostsCarousel:
        return <LatestBlogPostsCarousel entity={entity} key={key} />
      case EntityTypeEnum.Audio:
        return <AudioNew entity={entity} key={key} />
      case EntityTypeEnum.Agreement:
        return <Agreement entity={entity} key={key} />
      case EntityTypeEnum.Popup:
        return <PopupNew entity={entity} key={key} {...additionalProps} />
      case EntityTypeEnum.SearchResults:
        return <SearchResults entity={entity} key={key} />
      case EntityTypeEnum.Search:
        return <Search entity={entity} key={key} />
      default:
        return <div /> /* let's return empty div temporarily */
      // throw new Error(`unknown type ${entity.type} of node id = ${entity.id}`)
    }
  }
}
